import { GB_PATH, NI_PATH, VIEW_W, VIEW_H } from "@/lib/ukmap";

// Small UK silhouette glyph. Inherits colour via `currentColor` (fill).
export function UkGlyph({ className = "h-6 w-6" }) {
  return (
    <svg viewBox={`0 0 ${VIEW_W} ${VIEW_H}`} className={className} role="img" aria-label="United Kingdom" fill="currentColor">
      <path d={GB_PATH} />
      <path d={NI_PATH} />
    </svg>
  );
}
